'use es6';

import { getFullUrl } from 'hubspot-url-utils';
import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
import { useEffect } from 'react';
import CustomWidgetProps from 'reporting-ui-components/lib/CustomWidgetProps';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACTIVITY_FRAME = `${getFullUrl('app')}/activity-feed-embedded/${PortalIdParser.get()}/all?source=reporting`;
const StyledIframe = styled.iframe.withConfig({
  displayName: "ActivityFeed__StyledIframe",
  componentId: "eb9lrv-0"
})(["width:100%;flex-grow:1;border:", ";"], ({
  theme
}) => theme.borderWidth[0]);
function ActivityFeedViz({
  disableIframes = false,
  setIsRendered
}) {
  useEffect(() => {
    if (typeof setIsRendered === 'function') setIsRendered();
  }, [setIsRendered]);
  if (!disableIframes) {
    // @bend-expect trellis-tokenized
    return /*#__PURE__*/_jsx(StyledIframe, {
      src: ACTIVITY_FRAME
    });
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    justify: "center",
    align: "center",
    direction: "column",
    marginBlockStart: "300",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "empty-state-charts",
      height: 200
    }), /*#__PURE__*/_jsx(Text, {
      marginBlockStart: "300",
      as: "p",
      children: I18n.text('reporting-ui-components.customWidgets.activityFeed.emptyState.emailView')
    })]
  });
}
ActivityFeedViz.propTypes = CustomWidgetProps;
export default ActivityFeedViz;